import { defineComponent as _defineComponent } from 'vue'
import { watchEffect, ref, onMounted, onUnmounted } from '../../../../adapter-vue';
import Icon from '../../../common/Icon.vue';
import audioIcon from '../../../../assets/icon/msg-audio.svg';
import { isMobile } from '../../../../utils/env';

interface IEmits {
  (e: 'setAudioPlayed', messageID: string): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'message-audio',
  props: {
  content: {
    type: Object,
    default: () => ({}),
  },
  messageItem: {
    type: Object,
    default: () => ({}),
  },
},
  emits: ["setAudioPlayed"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'setAudioPlayed', messageID: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props




const data = ref();
const message = ref();
const isAudioPlaying = ref();
const audioRef = ref<HTMLAudioElement>();

onMounted(() => {
  if (audioRef.value) {
    audioRef.value.addEventListener('ended', onAudioEnded);
    audioRef.value.addEventListener('pause', onAudioPaused);
  }
});

onUnmounted(() => {
  if (audioRef.value) {
    audioRef.value.removeEventListener('ended', onAudioEnded);
    audioRef.value.removeEventListener('pause', onAudioPaused);
  }
});

watchEffect(() => {
  message.value = props.messageItem;
  data.value = props.content;
});

function play() {
  if (message.value.hasRiskContent || !audioRef.value) {
    return;
  }
  if (!audioRef.value.paused) {
    audioRef.value.pause();
    audioRef.value.currentTime = 0;
    isAudioPlaying.value = false;
    return;
  }
  const audios = document.getElementsByTagName('audio');
  Array.from(audios).forEach((audio) => {
    if (!audio.paused) {
      audio.pause();
      audio.currentTime = 0;
    }
  });
  audioRef.value.play();
  isAudioPlaying.value = true;
  if (message.value.flow === 'in') {
    emits('setAudioPlayed', message.value.ID);
  }
}

function onAudioEnded() {
  isAudioPlaying.value = false;
}

function onAudioPaused() {
  isAudioPlaying.value = false;
}

return { __sfc: true,emits, props, data, message, isAudioPlaying, audioRef, play, onAudioEnded, onAudioPaused, Icon, audioIcon, isMobile }
}

})